import * as t from 'io-ts';
import { ITimerMarkTypeItem, SimpleObjectInterface } from 'ws-voice-infinity-global-module/lib/interfaces';
import TIMER_MARK_STATUS, { TimerMarkStatusType } from '../../Global/enums/timerMarkStatus';
import TIMER_MARK_TYPE, { TimerMarkTypeType } from '../../Global/enums/timerMarkType';

export const ComplaintTimerType = t.interface({
    id: t.string,
    meetingId: t.string,
    complaintId: t.union([t.string, t.undefined]),
    markType: TimerMarkTypeType,
    markStatus: TimerMarkStatusType,
    startDate: t.union([t.string, t.number, t.null]),
    stopDate: t.union([t.string, t.number, t.null]),
    dueDate: t.union([t.string, t.number, t.null]),
    current: t.union([t.boolean, t.undefined]),
});

export interface ComplaintTimerDTO extends t.TypeOf<typeof ComplaintTimerType> {}

export class ComplaintTimer {
    id: string;
    meetingId: string;
    complaintId: string;
    markType: ITimerMarkTypeItem;
    markStatus: SimpleObjectInterface;
    startDate: Date | null;
    stopDate: Date | null;
    dueDate: Date | null;
    current?: boolean;

    constructor(params: ComplaintTimerDTO) {
        this.id = params.id;
        this.meetingId = params.meetingId;
        this.complaintId = params.complaintId ?? '';
        this.markType = params.markType ? TIMER_MARK_TYPE[params.markType] : TIMER_MARK_TYPE.MODERATION;
        this.markStatus = params.markStatus ? TIMER_MARK_STATUS[params.markStatus] : TIMER_MARK_STATUS.NORMAL;
        this.startDate = params.startDate ? new Date(params.startDate) : null;
        this.stopDate = params.stopDate ? new Date(params.stopDate) : null;
        this.dueDate = params.dueDate ? new Date(params.dueDate) : null;
        this.current = params.current;
    }
}
